/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetEmployees200ResponseInner,
} from '../models/index';
import {
    GetEmployees200ResponseInnerFromJSON,
    GetEmployees200ResponseInnerToJSON,
} from '../models/index';

/**
 * 
 */
export class EmployeesApi extends runtime.BaseAPI {

    /**
     */
    async getEmployeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetEmployees200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetEmployees200ResponseInnerFromJSON));
    }

    /**
     */
    async getEmployees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetEmployees200ResponseInner>> {
        const response = await this.getEmployeesRaw(initOverrides);
        return await response.value();
    }

}
